export const FluidCodes = [
  {
    fluidCode: "AA",
    fluidDescription: "Ambient Air",
  },
  {
    fluidCode: "AC",
    fluidDescription: "Acid",
  },
  {
    fluidCode: "AL",
    fluidDescription: "Alum",
  },
  {
    fluidCode: "BG",
    fluidDescription: "Biogas",
  },
  {
    fluidCode: "CG",
    fluidDescription: "Chlorine Gas",
  },
  {
    fluidCode: "CN",
    fluidDescription: "Calcium Nitrate",
  },
  {
    fluidCode: "CS",
    fluidDescription: "Chlorine Solution",
  },
  {
    fluidCode: "CT",
    fluidDescription: "Centrate",
  },
  {
    fluidCode: "DR",
    fluidDescription: "Drainage",
  },
  {
    fluidCode: "DS",
    fluidDescription: "Dewatered Sludge",
  },
  {
    fluidCode: "FE",
    fluidDescription: "Final Effluent",
  },
  {
    fluidCode: "FG",
    fluidDescription: "Fuel Gas",
  },
  {
    fluidCode: "FO",
    fluidDescription: "Fuel Oil",
  },
  {
    fluidCode: "FT",
    fluidDescription: "Filtrate",
  },
  {
    fluidCode: "GL",
    fluidDescription: "Glycol/Glycerin",
  },
  {
    fluidCode: "IA",
    fluidDescription: "Instrument Air",
  },
  {
    fluidCode: "IR",
    fluidDescription: "Ferric/Ferrous",
  },
  {
    fluidCode: "IW",
    fluidDescription: "Inlet Waste (Grit, Screening)",
  },
  {
    fluidCode: "LI",
    fluidDescription: "Liquors",
  },
  {
    fluidCode: "ME",
    fluidDescription: "Methanol",
  },
  {
    fluidCode: "ML",
    fluidDescription: "Mixed Liquors",
  },
  {
    fluidCode: "NA",
    fluidDescription: "Caustic",
  },
  {
    fluidCode: "NH",
    fluidDescription: "Ammonia",
  },
  {
    fluidCode: "NP",
    fluidDescription: "Non-Potable Water",
  },
  {
    fluidCode: "PA",
    fluidDescription: "Process Air",
  },
  {
    fluidCode: "PO",
    fluidDescription: "Polymer",
  },
  {
    fluidCode: "PW",
    fluidDescription: "Potable Water",
  },
  {
    fluidCode: "RA",
    fluidDescription: "Return Activated Sludge",
  },
  {
    fluidCode: "RS",
    fluidDescription: "Raw Sewage",
  },
  {
    fluidCode: "SA",
    fluidDescription: "Surplus Activated Sludge",
  },
  {
    fluidCode: "SC",
    fluidDescription: "Scum",
  },
  {
    fluidCode: "SL",
    fluidDescription: "Sludge",
  },
  {
    fluidCode: "SN",
    fluidDescription: "Sodium Nitrate",
  },
  {
    fluidCode: "SP",
    fluidDescription: "Supernatant",
  },
  {
    fluidCode: "SS",
    fluidDescription: "Sulfur Dioxide Solution",
  },
  {
    fluidCode: "ST",
    fluidDescription: "Steam",
  },
  {
    fluidCode: "TS",
    fluidDescription: "Thickened Sludge",
  },
  {
    fluidCode: "XS",
    fluidDescription: "Screened Sewage",
  },
];

export const instrumentType = [
  {
    ClassName: "Flow - General",
    instrumentType: "Flow Indicator",
  },
  {
    ClassName: "Flow - Electromagnetic",
    instrumentType: "Full Bore Flow Meter",
  },
  {
    ClassName: "Flow - Electromagnetic",
    instrumentType: "Reduced Bore Flow Meter",
  },
  {
    ClassName: "Flow - Electromagnetic",
    instrumentType: "Full Bore Flow Meter",
  },
  {
    ClassName: "Flow - General",
    instrumentType: "Flow Indicator",
  },
  {
    ClassName: "Flow - General",
    instrumentType: "Flow Switch",
  },
  {
    ClassName: "Flow - Variable Area",
    instrumentType: "Variable Area Flow Meter",
  },
  {
    ClassName: "Level - Float",
    instrumentType: "Level Float",
  },
  {
    ClassName: "Level - Electrode Conductive",
    instrumentType: "Level Probe",
  },
  {
    ClassName: "Level - General",
    instrumentType: "Level Switch",
  },
  {
    ClassName: "Level - Ultrasonic",
    instrumentType: "Level Ultrasonic",
  },
  {
    ClassName: "Level - Ultrasonic",
    instrumentType: "Borehole Level Ultrasonic",
  },
  {
    ClassName: "Pressure - General",
    instrumentType: "Pressure Indicator",
  },
  {
    ClassName: "Pressure - General",
    instrumentType: "Pressure Sensor",
  },
  {
    ClassName: "Pressure - General",
    instrumentType: "Differential Pressure Sensor",
  },
  {
    ClassName: "Quality - Free Chlorine",
    instrumentType: "Analytical Monitor",
  },
  {
    ClassName: "Quality - Total Chlorine",
    instrumentType: "Analytical Monitor",
  },
  {
    ClassName: "Quality - Turbidity",
    instrumentType: "Analytical Monitor",
  },
  {
    ClassName: "Quality - Iron",
    instrumentType: "Analytical Monitor",
  },
  {
    ClassName: "Quality - Phosphates",
    instrumentType: "Analytical Monitor",
  },
  {
    ClassName: "Quality - Ammonia",
    instrumentType: "Analytical Monitor",
  },
  {
    ClassName: "Quality - Ammonia",
    instrumentType: "Analytical Monitor",
  },
  {
    ClassName: "Quality - pH",
    instrumentType: "Analytical Monitor",
  },
  {
    ClassName: "Quality - Dissolved Oxygen",
    instrumentType: "Analytical Monitor",
  },
  {
    ClassName: "Quality - Nitrates",
    instrumentType: "Analytical Monitor",
  },
  {
    ClassName: "Quality - Nitrates",
    instrumentType: "Analytical Monitor",
  },
  {
    ClassName: "Quality - General",
    instrumentType: "Analytical Monitor",
  },
  {
    ClassName: "Temperature - General",
    instrumentType: "Temperature Sensor",
  },
];

export const transmitterMountingLocation = [
  {
    ClassName: "Flow - General",
    transmitterMountingLocation: "NA",
  },
  {
    ClassName: "Flow - Electromagnetic",
    transmitterMountingLocation: "Sensor",
  },
  {
    ClassName: "Flow - Electromagnetic",
    transmitterMountingLocation: "Remote",
  },
  {
    ClassName: "Flow - Variable Area",
    transmitterMountingLocation: "NA",
  },
  {
    ClassName: "Level - Float",
    transmitterMountingLocation: "NA",
  },
  {
    ClassName: "Level - Electrode Conductive",
    transmitterMountingLocation: "NA",
  },
  {
    ClassName: "Level - General",
    transmitterMountingLocation: "NA",
  },
  {
    ClassName: "Level - Ultrasonic",
    transmitterMountingLocation: "Remote",
  },
  {
    ClassName: "Level - Ultrasonic",
    transmitterMountingLocation: "Field",
  },
  {
    ClassName: "Level - Ultrasonic",
    transmitterMountingLocation: "NA",
  },
];

export const sensorMountingType = [
  {
    ClassName: "Level - Float",
    sensorMountingType: "NA",
  },
  {
    ClassName: "Level - Electrode Conductive",
    sensorMountingType: "NA",
  },
  {
    ClassName: "Level - General",
    sensorMountingType: "NA",
  },
  {
    ClassName: "Level - Ultrasonic",
    sensorMountingType: "Hinged",
  },
  {
    ClassName: "Level - Ultrasonic",
    sensorMountingType: "Fixed",
  },
  {
    ClassName: "Level - Ultrasonic",
    sensorMountingType: "NA",
  },
];

export const pipeSpecs = [
  {
    materialCode: "DISS",
    materialDescription: "PN16 Ductile Iron Sewage Socketed",
  },
  {
    materialCode: "DISF",
    materialDescription: "PN16 Ductile Iron Sewage Flanged",
  },
  {
    materialCode: "DIWS",
    materialDescription: "PN16 Ductile Iron Water Socketed",
  },
  {
    materialCode: "DIWF",
    materialDescription: "PN16 Ductile Iron Water Flanged",
  },
  {
    materialCode: "304SS10",
    materialDescription: "Stainless Steel Sch 10 304",
  },
  {
    materialCode: "304SS5",
    materialDescription: "Stainless Steel Sch 5 304",
  },
  {
    materialCode: "304SS40",
    materialDescription: "Stainless Steel Sch 40 304",
  },
  {
    materialCode: "316SS10",
    materialDescription: "Stainless Steel Sch 10 316",
  },
  {
    materialCode: "316SS5",
    materialDescription: "Stainless Steel Sch 5 316",
  },
  {
    materialCode: "316SS40",
    materialDescription: "Stainless Steel Sch 40 316",
  },
  {
    materialCode: "304SSM15",
    materialDescription: "Tru-Bore 1.5mm WT 304",
  },
  {
    materialCode: "304SSM20",
    materialDescription: "Tru-Bore 2.0mm WT 304",
  },
  {
    materialCode: "304SSM25",
    materialDescription: "Tru-Bore 2.5mm WT 304",
  },
  {
    materialCode: "304SSM30",
    materialDescription: "Tru-Bore 3.0mm WT 304",
  },
  {
    materialCode: "304SSM40",
    materialDescription: "Tru-Bore 4.0mm WT 304",
  },
  {
    materialCode: "316SSM15",
    materialDescription: "Tru-Bore 1.5mm WT 316",
  },
  {
    materialCode: "316SSM20",
    materialDescription: "Tru-Bore 2.0mm WT 316",
  },
  {
    materialCode: "316SSM25",
    materialDescription: "Tru-Bore 2.5mm WT 316",
  },
  {
    materialCode: "316SSM30",
    materialDescription: "Tru-Bore 3.0mm WT 316",
  },
  {
    materialCode: "316SSM40",
    materialDescription: "Tru-Bore 4.0mm WT 316",
  },
  {
    materialCode: "316SSTH",
    materialDescription: "Stainless Steel Sch 40 316 Threaded Pipe & Fittings",
  },
  {
    materialCode: "304SSTH",
    materialDescription: "Stainless Steel Sch 40 304 Threaded Pipe & Fittings",
  },
  {
    materialCode: "11PE80A",
    materialDescription: "Polyethylene Pipe, SDR 11, PE80, Black",
  },
  {
    materialCode: "11PE80U",
    materialDescription: "Polyethylene Pipe, SDR 11, PE80, Blue",
  },
  {
    materialCode: "11PE100A",
    materialDescription: "Polyethylene Pipe, SDR 11, PE100, Black",
  },
  {
    materialCode: "11PE100U",
    materialDescription: "Polyethylene Pipe, SDR 11, PE100, Blue",
  },
  {
    materialCode: "17PE100A",
    materialDescription: "Polyethylene Pipe, SDR 17, PE100, Black",
  },
  {
    materialCode: "17PE100U",
    materialDescription: "Polyethylene Pipe, SDR 17, PE100, Blue",
  },
  {
    materialCode: "21PE100A",
    materialDescription: "Polyethylene Pipe, SDR 21, PE100, Black",
  },
  {
    materialCode: "21PE100U",
    materialDescription: "Polyethylene Pipe, SDR 21, PE100, Blue",
  },
  {
    materialCode: "26PE100A",
    materialDescription: "Polyethylene Pipe, SDR 26, PE100, Black",
  },
  {
    materialCode: "26PE100U",
    materialDescription: "Polyethylene Pipe, SDR 26, PE100, Blue",
  },
  {
    materialCode: "PVCUC",
    materialDescription:
      "PVC-U Pipe Imperial System Plain, Class C 9 bar @ 20°C - Durapipe",
  },
  {
    materialCode: "PVCUD",
    materialDescription:
      "PVC-U Pipe Imperial System Plain, Class D 12 bar @ 20°C - Durapipe",
  },
  {
    materialCode: "PVCUE",
    materialDescription:
      "PVC-U Pipe Imperial System Plain, Class E 15 bar @ 20°C - Durapipe",
  },
  {
    materialCode: "PVCU7",
    materialDescription:
      "PVC-U Pipe Imperial System Threaded Ends, Class 7 12 bar @ 20°C - Durapipe",
  },
  {
    materialCode: "PVCU10",
    materialDescription:
      "PVC-U Pipe Metric System Plain, PN10, 10 bar @ 20°C - Durapipe",
  },
  {
    materialCode: "PVCU16",
    materialDescription:
      "PVC-U Pipe Metric System Plain, PN16, 16 bar @ 20°C - Durapipe",
  },
  {
    materialCode: "Cu",
    materialDescription: "Mapress Copper Pipe and Fittings",
  },
  {
    materialCode: "CSEC",
    materialDescription: "Carbon Steel Epoxy Coated - Schedule 40",
  },
  {
    materialCode: "CS",
    materialDescription: "Carbon Steel - Schedule 40",
  },
  {
    materialCode: "CSG",
    materialDescription: "Carbon Steel Galvanised Threaded",
  },
  {
    materialCode: "OSMA",
    materialDescription: "OSMA Drainage",
  },
];
